import { render, staticRenderFns } from "./DormerPlacementRadioFormPart.vue?vue&type=template&id=c4af8886"
import script from "./DormerPlacementRadioFormPart.vue?vue&type=script&lang=js"
export * from "./DormerPlacementRadioFormPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports